import { updateVMRecordings } from '../../store/action/vm';

export const recordingEvent = (message, helpers, store) => {
  console.log(`custom vm recordings update`, message);
  const { dispatch } = store;
  dispatch(updateVMRecordings(message));
};
